/* detect webp support */
let dataType = '';
let webpSupport = false;
async function supportsWebp() {
	if(!self.createImageBitmap) return false;
	const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
	const blob = await fetch(webpData).then(r => r.blob());
	return createImageBitmap(blob).then(() => true, () => false);
}

(async () => {
	if(await supportsWebp()) {
		dataType = 'webp';
		webpSupport = true;
	} else {
		dataType = 'standard';
	}
	document.addEventListener('scroll', throttle(blurUpImages, 250));
	window.onresize = blurUpImages();
})();

const throttle = (func, limit) => {
	let lastFunc;
	let lastRan;
	return function() {
		const context = this;
		const args = arguments;
		if (!lastRan) {
			func.apply(context, args);
			lastRan = Date.now();
		} else {
			clearTimeout(lastFunc);
			lastFunc = setTimeout(function() {
				if ((Date.now() - lastRan) >= limit) {
					func.apply(context, args)
					lastRan = Date.now()
				}
			}, limit - (Date.now() - lastRan));
		}
	}
}

const blurUpImages = () => {
	const blurUpImages = document.querySelectorAll('.blur-up');
	if(blurUpImages) {
		blurUpImages.forEach(function(item) {
			const fullImage = item.querySelector('.full-image');
			if(!fullImage.classList.contains('image-loaded')) {
				/* number of pixels the image must extend past the viewport's edge to load */
				const buffer = 0;
				const offset = item.getBoundingClientRect();
				const itemTop = Math.floor(offset.top);
				const itemBottom = Math.floor(offset.bottom);
				const itemHeight = item.offsetHeight;
				if(itemTop >= (-itemHeight + buffer) && itemBottom <= (window.innerHeight || document.documentElement.clientHeight) + (itemHeight - buffer)) {
					let imageActive = null;
					if(fullImage.children.length > 1) {
						imageActive = fullImage.querySelector('[data-type="' + dataType + '"]');
					} else {
						imageActive = fullImage.children[0];
					}
					img = new Image;
					img.srcset = imageActive.srcset;
					img.onload = () => {
						fullImage.classList.add('image-loaded');
					}
				}
			}
		});
	}
}
